import React, { useState } from 'react';

interface ClaimConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (notes: string) => void;
  selectedCount: number;
  isLoading: boolean;
}

const ClaimConfirmationModal: React.FC<ClaimConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  selectedCount,
  isLoading
}) => {
  const [notes, setNotes] = useState("");

  const handleConfirm = () => {
    onConfirm(notes);
  };

  const handleCancel = () => {
    setNotes("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[2000] p-4">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md">
        <h3 className="text-[20px] leading-7 font-medium text-gray-800 mb-4">
          Confirm Shift Claim
        </h3>
        
        <div className="mb-4">
          <p className="text-[16px] leading-6 text-gray-600">
            You are about to claim <span className="font-semibold">{selectedCount}</span> shift{selectedCount > 1 ? 's' : ''}.
          </p>
        </div>

        <div className="mb-6">
          <label htmlFor="claimNotes" className="block text-[16px] leading-6 font-medium text-gray-700 mb-2">
            Notes (Optional)
          </label>
          <textarea
            id="claimNotes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={3}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none resize-none text-[16px]"
            placeholder="Add any additional information or special requirements..."
          />
          <p className="text-xs text-gray-500 mt-1">
            This information will be shared with your supervisor
          </p>
        </div>
        
        <div className="flex space-x-3">
          <button
            type="button"
            onClick={handleCancel}
            disabled={isLoading}
            className="flex-1 py-2 px-4 border border-gray-300 rounded-lg text-[16px] font-medium text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            No, Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={isLoading}
            className="flex-1 py-2 px-4 bg-transparent border border-blue-600 text-blue-600 rounded-lg text-[16px] font-medium hover:bg-blue-50 transition-colors disabled:opacity-50"
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
                Claiming...
              </div>
            ) : (
              'Yes, Claim Shifts'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClaimConfirmationModal;
